import { map } from "rxjs/operators";
import ActionTypes from "./ActionTypes.js";
import { ofType, combineEpics } from "redux-observable";
import "rxjs-compat";
import ActionProgressionsActions from "./Actions.js";
const updateActiveProgressionsListPropsEpic = (action$) => {
  return action$.pipe(
    ofType(ActionTypes.UPDATE_ACTIVE_PROGRESSION_LIST_PROPS),
    map((action) => {
      return ActionProgressionsActions.updateActiveProgressionsListPropsData(action.payload);
    })
  );
};
const activeProgressionsListPropsEpics = combineEpics(updateActiveProgressionsListPropsEpic);
export {
  activeProgressionsListPropsEpics,
  updateActiveProgressionsListPropsEpic
};
//# sourceMappingURL=ActiveProgressionsListPropsEpic.js.map
